import React from 'react';
import Slider from 'react-slick';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Quote from '@/public/assets/quote.svg';
import Arrow from '@/public/assets/arrow.svg';

const info = [
  {
    id: 1,
    title: 'What Our Members Think of Baywood',
    subtitle: 'A spectacular golf course in Delaware ',
    description:
      'Just played your course yesterday for the first time. I was with a groups on 16, and every golfer said this was one of the best courses they ever plated. I was amazed by the course conditions and beauty of the entire property. It was even more amazing for a public/resort fold course that gets 200 rounds a day. The course superintendent and the entire staff are doing a fantastic job. Can’t wait to come back.',
    author: 'Robert - Golfer',
  },
  {
    id: 2,
    title: 'What Our Members Think of Baywood 2',
    subtitle: 'A spectacular golf course in Delaware ',
    description:
      'Just played your course yesterday for the first time. I was with a groups on 16, and every golfer said this was one of the best courses they ever plated. I was amazed by the course conditions and beauty of the entire property. It was even more amazing for a public/resort fold course that gets 200 rounds a day. The course superintendent and the entire staff are doing a fantastic job. Can’t wait to come back.',
    author: 'Robert - Golfer',
  },
  {
    id: 3,
    title: 'What Our Members Think of Baywood 3',
    subtitle: 'A spectacular golf course in Delaware ',
    description:
      'Just played your course yesterday for the first time. I was with a groups on 16, and every golfer said this was one of the best courses they ever plated. I was amazed by the course conditions and beauty of the entire property. It was even more amazing for a public/resort fold course that gets 200 rounds a day. The course superintendent and the entire staff are doing a fantastic job. Can’t wait to come back.',
    author: 'Robert - Golfer',
  },
];

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: '110px',
    paddingBottom: '80px',
    maxWidth: '700px',
    [theme.breakpoints.down('xl')]: {
      paddingTop: '40px',
      paddingBottom: '40px',
      maxWidth: '100%',
    },
  },
  sliderContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  author: {
    color: '#3C8047',
    fontFamily: 'Lato',
    fontSize: '21px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '27px',
  },
  subtitleContainer: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
  },
  line: {
    margin: 0,
    height: 2,
    backgroundColor: '#212121',
    width: '180px',
    [theme.breakpoints.down('md')]: {
      width: '80px',
    },
  },
  subtitle: {
    margin: 0,
    color: '#212121',
    fontFamily: 'Playfair Display',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '28px',
    paddingLeft: '32px',
    paddingRight: '32px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      lineHeight: '20px',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  title: {
    color: '#212121',
    fontFamily: 'Playfair Display',
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '54px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
      lineHeight: '32px',
    },
  },
  body: {
    color: '#212121',
    fontFamily: 'Lato',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '27px',
    maxWidth: '600px',
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  boxContainer: {
    marginTop: '32px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '600px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: '16px',
    },
  },
}));

const MoreInfoCarousel = ({ items }) => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const classes = useStyles();

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      <Box className={classes.container}>
        <Slider {...settings}>
          {info.map((info) => (
            <Box key={info.id} className={classes.sliderContainer}>
              <Box>
                <Box className={classes.subtitleContainer}>
                  <Box className={classes.line} />
                  <Typography className={classes.subtitle}>
                    {info.subtitle}
                  </Typography>
                  <Box className={classes.line} />
                </Box>
                <Typography className={classes.title}>{info.title}</Typography>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'start',
                  flexDirection: 'row',
                  gap: '18px',
                }}
              >
                <Quote />
                <Box style={{ paddingTop: '16px' }}>
                  <Typography className={classes.body}>
                    {info.description}
                  </Typography>
                  <Box className={classes.boxContainer}>
                    <Typography className={classes.author}>
                      {info.author}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

function SampleNextArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      style={{
        ...style,
        background: 'white',
        color: 'black',
        width: '64px',
        height: '56px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: '50%',
        right: '-62px',
        transform: 'translate(0%, -50%)',
        borderRadius: '0px 365px 365px 0px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      }}
      onClick={onClick}
    >
      <Arrow />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { style, onClick } = props;
  return (
    <div
      style={{
        ...style,
        background: 'white',
        color: 'black',
        width: '64px',
        height: '56px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        left: '-62px',
        top: '50%',
        transform: 'translate(0%, -50%)',
        borderRadius: '365px 0px 0px 365px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      }}
      onClick={onClick}
    >
      <Arrow
        style={{
          transform: 'rotate(180deg)',
        }}
      />
    </div>
  );
}

export default MoreInfoCarousel;
